import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  button: {
    '&$disabled': {
      color: theme.palette.primary.dark,
    },
  },
  disabled: {},
}));
